import SP175W from '@elem/compPage/SP175W';
import dynamic from 'next/dynamic';
import css from './index.module.scss';
import PageLayout from '@/components/PageLayout';
import { useGlobal } from '@/utils/useGlobal';
import SEOlinksA from '@/components/SEOlinksA';
import ProductNav from '@/components/ProductCommon/ProductNav';
import ProductSpecs from '@/components/ProductCommon/ProductSpecs';
import ProductSupport from '@/components/ProductCommon/ProductSupport';
import { getProductMsg, getProductFromGeneralKey } from '@/utils/productGetServerSideProps';
import { useSupportData } from '@/utils/hooks';
import { redirectTo404 } from '@/utils/redirect404';

// 产品详情页参数
const productName = '175w-rigid-solar-panel';
const generalKey = 'product_sp_175w_rigid_solar_panel';
const white_list = ['us', 'eu', 'de', 'fr', 'es', 'it', 'uk', 'br', 'mx'];
export default function Page({ SEO }: any) {
    const { useLang, useRouter, gloproductlist } = useGlobal();
    const router = useRouter();
    const { locale } = router;
    const { t } = useLang('solar_panel_175w');
    const theme = 'white';
    const GtmPageLoad = dynamic(() => import('@/components/GtmPageLoad'), { ssr: false });
    // 从全局的列表中--获取产品详情的基本信息
    const productMsg = getProductFromGeneralKey({ gloproductlist, generalKey: generalKey });
    const [resProductCatagory, productDetail, supportData] = useSupportData(getProductMsg, locale, productMsg);

    // 切换tab
    const tabState = (val: any) => {
        document.querySelector('.product-tab.show-tab')?.classList.remove('show-tab');
        document.querySelector(`.product-tab-${val}`)?.classList.add('show-tab');
    };

    return (
        <>
            <SEO title={productMsg?.title || t('seo_title')} description={productMsg?.description || t('seo_desc')} />
            <SEOlinksA list={white_list} locale={locale} pathname={'175w-rigid-solar-panel'} />
            <GtmPageLoad />
            <PageLayout className={`${css.productcontent} ${theme} product_common product_common_real`} theme={theme}>
                <ProductNav
                    className="wbg"
                    title={productMsg?.name}
                    theme={theme}
                    buyLink={productMsg?.buyLink || ''}
                    callback={tabState}
                    productKey={productName}
                />
                <div className="product-tab product-tab-Overview show-tab">
                    <SP175W />
                </div>
                <div className="product-tab product-tab-Specs">
                    <ProductSpecs theme={theme} productDetail={productDetail} resProductCatagory={resProductCatagory} />
                </div>
                <div className="product-tab product-tab-Support">
                    <ProductSupport theme={theme} supportData={supportData}></ProductSupport>
                </div>
            </PageLayout>
        </>
    );
}
export async function getServerSideProps({ locale }: any) {
    if (!white_list.includes(locale)) {
        return redirectTo404();
    }
    return {
        props: {},
    };
}
